import { useMutation } from "@tanstack/react-query";
import api from "../utils/api";
const fetchUpdateAgenda = (data) => {
  return api.put(`/agenda`, data);
};

export const useUpdateAgendaQuery = () => {
  return useMutation({ mutationFn: fetchUpdateAgenda });
};
